import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './infoscreen.js';

// Initialize Alpine JS
Alpine.plugin(intersect);
Alpine.plugin(focus);

window.Alpine = Alpine;

Alpine.start();

// SLIDER

const sliders = document.querySelectorAll('.swiper');

for (const slider of sliders) {
	const responsive = slider.dataset.swiperResponsive;
	const options = slider.dataset.swiperAutoSlides ?
		{
			autoHeight: false,
			breakpoints: {},
			slidesPerView: 'auto',
			spaceBetween: 20,
			speed: 500,
		} :
		{
			autoHeight: true,
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1000,
			breakpoints: responsive ? {
				640: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			} : {},
		};

	const swiper = new Swiper(slider, {
		a11y: {
			prevSlideMessage: 'Vorherige Folie',
			nextSlideMessage: 'Nächste Folie',
			firstSlideMessage: 'Das ist die erste Folie',
			lastSlideMessage: 'Das ist die letzte Folie',
			paginationBulletMessage: 'Gehe zu Folie {{index}}',
			slideLabelMessage: 'Folie {{index}} / {{slidesLength}}',
		},
		loop: slider.dataset.swiperLoop === 'true',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		parallax: {
			enabled: true,
		},
		watchOverflow: true,
		modules: [A11y, Navigation, Pagination],
		...options,
	});

	swiper.once('slideChange', () => {
		const parallax = slider.querySelectorAll('[data-parallax]');

		for (const item of parallax) {
			item.dataset.parallaxActive = true;
		}
	});

	if (swiper.slides.length <= 1) {
		swiper.destroy();
	}
}

// Spendenformular mit Betrag aus Slider befüllen

new URL(window.location.href).searchParams.forEach((x, y) => {
	const el = document.getElementById(y);
	if (!el) return;
	el.value = x;
});

// Suche leeren

function resetSearch(input) {
	const params = new URL(document.location).searchParams;

	if (params.size == 0) {
		return;
	}

	input.value = "";
	params.delete("tx_solr[q]");
	document.location.search = params.toString();
}

// Testamentsrechner einblenden

function showTestamentsrechner() {
	Spotlight.show([{
		'autohide': false,
		'zoom-in': false,
		'zoom-out': false,
		'autofit': false,
		'media': 'node',
		'theme': 'white',
		'src': (function() {
			const iframe = document.createElement("iframe");
			iframe.src = "https://testamentsrechner.vergissmeinnicht.at/samariterbund";
			return iframe;
		}())
	}]);
}
